// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1Fng8","verticalPaddingLarge":"styles_verticalPaddingLarge__1GJvJ"};